<template>
  <div>
    <div class="detial-cont-view">
      <a-descriptions layout="vertical">
        <a-descriptions-item>
          <span slot="label">单位名称<span class="required">*</span> </span>
          <a-tooltip placement="topLeft" :title="form.unitName">
            <div>
              <a-input
                v-if="form.id"
                class="w300"
                placeholder="请添加"
                v-model="form.unitName"
                disabled
              />
              <a-select
                v-else
                class="w300"
                placeholder="请选择"
                v-model="form.organizationId"
                :disabled="disabled"
              >
                <a-select-option
                  v-for="item in app.organizationUserList"
                  :value="item.organizationId"
                  :key="item.organizationId"
                >
                  {{ item.organizationname }}</a-select-option
                >
              </a-select>
            </div>
          </a-tooltip>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">责任人<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入责任人"
            v-model="form.responsiblepeople"
            :disabled="disabled"
            @change="emitChange('responsiblepeople', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">是否持证上岗<span class="required">*</span> </span>
          <a-select
            class="w300"
            v-model="form.workLicense"
            placeholder="请选择是否持证上岗"
            @change="emitChange()"
            :disabled="disabled"
          >
            <template v-for="(item, index) in bytype.whetherList">
              <a-select-option :value="item.valuename" :key="index">
                {{ item.keyname }}
              </a-select-option>
            </template>
          </a-select>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">品牌型号<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入品牌型号"
            v-model="form.brandModel"
            :disabled="disabled"
            @change="emitChange('brandModel', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">吨位<span class="required">*</span> </span>
          <a-input-number
            :min="0"
            :max="999999999"
            class="w300"
            placeholder="请输入吨位"
            v-model="form.tonnage"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">燃料类型<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入燃料类型"
            v-model="form.fuelType"
            :disabled="disabled"
            @change="emitChange('fuelType', 85)"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">初始构建日期<span class="required">*</span> </span>
          <a-date-picker
            class="w300"
            v-model="form.initialDate"
            valueFormat="YYYY-MM-DD"
            placeholder="请选择初始构建日期"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">本次检测日期<span class="required">*</span> </span>
          <a-date-picker
            class="w300"
            v-model="form.thisDetectionTime"
            valueFormat="YYYY-MM-DD"
            placeholder="请选择本次检测日期"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label"
            >检测周期（年）<span class="required">*</span>
          </span>
          <a-input-number
            :min="0"
            :max="999999999"
            class="w300"
            placeholder="请输入检测周期（年）"
            v-model="form.detectionPeriod"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">下次检测日期<span class="required">*</span> </span>
          <a-date-picker
            class="w300"
            v-model="form.nextDetectionTime"
            valueFormat="YYYY-MM-DD"
            placeholder="请选择下次检测日期"
            :disabled="disabled"
            @change="emitChange()"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">使用状态<span class="required">*</span> </span>
          <a-select
            class="w300"
            v-model="form.usestate"
            placeholder="请选择使用状态"
            :disabled="disabled"
            @change="emitChange()"
          >
            <template v-for="(item, index) in bytype.boilerTypeList">
              <a-select-option :value="item.valuename" :key="index">
                {{ item.keyname }}
              </a-select-option>
            </template>
          </a-select>
        </a-descriptions-item>
        <br />
        <a-descriptions-item label="备注">
          <a-input
            class="w500"
            type="textarea"
            :auto-size="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入备注"
            v-model="form.title"
            :disabled="disabled"
            @change="emitChange('title', 200)"
          />
        </a-descriptions-item>
      </a-descriptions>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: ['disabled', 'resData', 'formData'],
  model: {
    event: 'input',
    prop: 'formData'
  },
  data() {
    return {
      form: {}
    }
  },
  watch: {
    resData(val) {
      this.form = this.resData
    }
  },
  mounted() {
    this.getBoilerTypeList()
    this.getWhetherList()
    // 获取组织机构
    this.getorganizationUserList()
    if (!this.form.id) {
      // 新增
      this.$set(
        this.form,
        'organizationId',
        this.$store.state.app.organizationId
      )
    }
  },
  computed: {
    ...mapState(['app', 'bytype'])
  },
  methods: {
    ...mapActions([
      'getBoilerTypeList',
      'getWhetherList',
      'getorganizationUserList'
    ]),
    // 值更改时 向父组件传值
    emitChange(v, maxNum) {
      if (v) {
        this.eightyfive(v, maxNum)
      }
      this.$emit('input', this.form)
    }, // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.form[v].length > maxNum) {
        this.form[v] = this.form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.detial-cont-view {
  background: #fff;
  padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/baseInfoManagement/specialEquipBoiler/components/formBaseInfo.vue